import type { ReactNode } from 'react';
import ArSav from '../ui/ArSav.tsx';
import CsoSav from '../ui/CsoSav.tsx';

// Illusztratív, statikus minta a márkapanelhez; nem valós adat.
const MINTA_SZAKASZOK = [
  { kulcs: 'uj', db: 4, cimke: 'Új' },
  { kulcs: 'elerve', db: 5, cimke: 'Elérve' },
  { kulcs: 'szemle', db: 3, cimke: 'Szemle' },
  { kulcs: 'megbizas', db: 2, cimke: 'Megbízás' },
];

function Marka() {
  return (
    <div className="flex items-center gap-2.5">
      <img src="/ertekbecslo-logo.png" alt="" width="108" height="130" className="h-[30px] w-auto" />
      <div>
        <b className="block text-sm font-semibold tracking-[-0.01em]">Irodai felület</b>
        <span className="block text-xs tracking-[-0.01em] text-szoveg-halk">ingatlanertekmeghatarozas.hu</span>
      </div>
    </div>
  );
}

/** Közös váz a belépési oldalaknak: asztalon kétoszlopos (márkapanel + űrlap), mobilon egyoszlopos. A `szeles` a hosszabb űrlapokhoz (pl. regisztráció) szélesebb oszlopot ad. */
export default function BelepesKeret({ cim, szeles = false, children }: { cim: string; szeles?: boolean; children: ReactNode }) {
  return (
    <main className="grid min-h-dvh bg-hatter-melyen lg:grid-cols-[minmax(0,1.05fr)_minmax(0,1fr)]">
      <aside aria-hidden className="relative hidden flex-col justify-between gap-12 border-r border-vonal bg-hatter p-12 lg:flex xl:p-16">
        <Marka />
        <div className="grid max-w-lg gap-10">
          <div className="grid gap-3">
            <p className="text-3xl font-light tracking-[-0.03em] xl:text-4xl">Minden érdeklődő egy helyen, a visszahívástól a megbízásig.</p>
            <p className="text-szoveg-halk">Az online árbecslésből érkező érdeklődők itt várják a hívásodat, és a helyszíni szemléig kísérheted őket.</p>
          </div>
          <div className="grid gap-6">
            <CsoSav nev="Minta csővezeték" szakaszok={MINTA_SZAKASZOK} />
            <div className="max-w-xs">
              <ArSav min={71_000_000} max={96_000_000} kozep={83_000_000} skalaMin={40_000_000} skalaMax={140_000_000}
                felirat={<><b>71–96</b> millió Ft</>} />
            </div>
          </div>
        </div>
        <p className="text-sm text-szoveg-halk">Az adatok a KSH adásvételi adatai alapján készülnek.</p>
      </aside>
      <div className="grid place-items-center px-4 py-8 md:px-10">
        <div className={`grid w-full gap-7 ${szeles ? 'max-w-2xl' : 'max-w-md'}`}>
          <div className="lg:hidden"><Marka /></div>
          <div className="grid gap-5 rounded-[22px] border border-vonal bg-hatter p-5 sm:p-7 lg:border-0 lg:bg-transparent lg:p-0">
            <h1 className="text-2xl font-medium tracking-[-0.025em] lg:text-3xl">{cim}</h1>
            {children}
          </div>
        </div>
      </div>
    </main>
  );
}
